import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";

import { StateType } from "../../../../utils/types";
import { createAssignment } from "../../../../redux/educator/actions";
import { selectAssignmentSubmitLoading } from "../../../../redux/educator/selector";

const mapStateToProps = (state: StateType) => ({
  submitLoading: selectAssignmentSubmitLoading(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators(
    {
      createAssignment,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
